import { DadosProfissionais } from '../../../shared/dados-profissionais/model/dados-profissionais';
import { Endereco } from './endereco-cliente';
import { TelefoneCliente } from './telefone-cliente';
import { getFoneEmpresa, allTelefones, formatDateMiliseconds, getFoneArray } from '../../../shared/helper/utils';
import { TipoComprovanteRenda } from './tipo-comprovante-renda';
import { EmpresaPrestacaoServico } from '../../../shared/dados-profissionais/model/empresa-prestacao-servico';
import { ClienteReferencia } from './cliente-referencia';
import { isEmpty } from 'lodash';

export class Cliente {
  public id: number;
  public cpf: string;
  public nome = '';
  public renda: number;
  public rendaFutura: boolean;
  public tipoComprovanteRenda: TipoComprovanteRenda[];
  public outroComprovanteRenda: string;
  public dataNascimento;
  public email: string;
  public nomeMae: any;
  public nomePai = '';
  public idTipoDocumento: number;
  public rgIe: string;
  public rgIeUf: string;
  public rgIeData;
  public rgIeEmissor: string;
  public idEstadoCivil: string;
  public idNacionalidade: number;
  public naturalDe: string;
  public naturalDeUf: string;
  public clientePpe: string;
  public fatca: boolean;
  public tipoEnderecoCorrespondencia;
  public valorPatrimonio: number;
  public dadoProfissional = new DadosProfissionais();
  public clienteReferencias: any[] = [];
  public enderecos = new Endereco();
  public enderecoCorrespondencia = new Endereco();
  public telefones = new TelefoneCliente();
  public condutorCaminhao: string;
  public tipoTransporte: number;
  public tipoTransporteOutro: string;
  public prestaServicoOutraEmpresa: string;
  public empresaPrestacaoServico = new EmpresaPrestacaoServico();

  get proposta() {
    return {
      id: this.id,
      cpf: this.cpf.replace(/\D/g, ''),
      nome: this.nome,
      renda: this.renda,
      email: this.email,
      nomeMae: this.nomeMae,
      nomePai: this.nomePai,
      idTipoDocumento: this.idTipoDocumento,
      rgIe: this.rgIe,
      rgIeUf: this.rgIeUf,
      rgIeDt: formatDateMiliseconds(this.rgIeData),
      rgIeEmissor: this.rgIeEmissor,
      idEstadoCivil: this.idEstadoCivil,
      idNacionalidade: this.idNacionalidade,
      naturalDe: this.naturalDe,
      naturalDeUf: this.naturalDeUf,
      clientePpe: this.clientePpe === 'false' || this.clientePpe === 'N' ? 'N' : 'S',
      fatca: this.fatca ? this.fatca : false,
      valorPatrimonio: this.valorPatrimonio,
      condutorCaminhao: this.condutorCaminhao ? this.condutorCaminhao : 'N',
      tipoTransporte: this.tipoTransporte,
      tipoTransporteOutro: this.tipoTransporteOutro,
      empresaPrestacaoServico: !isEmpty(this.empresaPrestacaoServico) ? this.empresaPrestacaoServicoPayload() : undefined,
      telefones: allTelefones(this.telefones),
      enderecos: this.enderecosPayload(this.enderecos, this.enderecoCorrespondencia),
      tipoEnderecoCorresp: this.tipoEnderecoCorrespondencia,
      dadoProfissional: {
        idClasseProfissional: this.dadoProfissional.idClasseProfissional,
        idProfissao: this.dadoProfissional.idProfissao,
        idGrupoProfissao: this.dadoProfissional.idGrupoProfissao,
        nomeEmpresa: this.dadoProfissional.nomeEmpresa,
        telefone: getFoneEmpresa(this.dadoProfissional.telefoneEmpresa),
        endereco: !isEmpty(this.dadoProfissional.empresa.endereco) ? this.dadoProfissional.empresa.endereco : undefined,
        tempoExperienciaRamo: this.dadoProfissional.tempoExperienciaRamo,
        familiaresRamo: this.dadoProfissional.familiaresRamo
      },
      clienteReferencias: this.clienteReferencias,
    };

  }

  empresaPrestacaoServicoPayload() {
    const { ddd, numero } = getFoneEmpresa(this.empresaPrestacaoServico.telefone);
    return {
      ...this.empresaPrestacaoServico,
      ddd,
      telefone: numero,
    };
  }

  enderecosPayload(...data) {
    return data
      .filter(endereco => endereco.idTipoEndereco)
      .map(item => {
        return {
          idTipoEndereco: item.idTipoEndereco,
          uf: item.uf,
          cidade: item.cidade,
          endereco: item.endereco,
          bairro: item.bairro,
          numero: item.numero,
          complemento: item.complemento,
          cep: item.cep,

          tempoResidencia: item.tempoResidencia,
          condicaoResidencia: item.condicaoResidencia,
        };
      });
  }
}
